const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface Event {
  id: string;
  source: string;
  source_id?: string;
  source_url?: string;
  title: string;
  description?: string;
  start_time: string;
  end_time?: string;
  venue_name?: string;
  venue_address?: string;
  venue_lat?: number;
  venue_lng?: number;
  url?: string;
  image_url?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CalendarDayData {
  date: string;
  event_count: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// Events API
export async function getEvents(date?: string, start?: string, end?: string): Promise<Event[]> {
  const params = new URLSearchParams();
  if (date) params.append('date', date);
  if (start) params.append('start', start);
  if (end) params.append('end', end);

  const response = await fetch(`${API_BASE_URL}/events?${params}`);
  const data: ApiResponse<Event[]> = await response.json();

  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch events');
  }

  return data.data || [];
}

export async function getEventById(id: string): Promise<Event> {
  const response = await fetch(`${API_BASE_URL}/events/${id}`);
  const data: ApiResponse<Event> = await response.json();

  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch event');
  }

  return data.data!;
}

export async function submitEvent(event: {
  title: string;
  description?: string;
  start_time: string;
  end_time?: string;
  venue_name?: string;
  venue_address?: string;
  url?: string;
  submitter_email?: string;
}): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/events/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  });

  const data: ApiResponse<any> = await response.json();

  if (!data.success) {
    throw new Error(data.error || 'Failed to submit event');
  }

  return data.data;
}

// Calendar API
export async function getCalendarMonth(year: number, month: number): Promise<CalendarDayData[]> {
  const response = await fetch(
    `${API_BASE_URL}/calendar/month?year=${year}&month=${month}`
  );
  const data: ApiResponse<CalendarDayData[]> = await response.json();

  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch calendar data');
  }

  return data.data || [];
}
